import * as React from 'react';
import PropsChecker from '@telia-front/props-checker';
import SidemenuNav from '../sidemenu-nav/sidemenu-nav';
const Sidemenu = (props) => {
    return (React.createElement(PropsChecker, { componentProps: props, componentName: "Sidemenu", defaultValueName: "defaultTree", valueName: "tree", onChangeNames: "onTreeChange" },
        React.createElement(SidemenuInner, Object.assign({}, props))));
};
export default Sidemenu;
export class SidemenuInner extends React.Component {
    constructor(props) {
        super(props);
        this.handleTreeChange = (tree) => {
            if (typeof this.props.tree === 'undefined') {
                this.setState({
                    tree,
                });
            }
            if (this.props.onTreeChange) {
                this.props.onTreeChange(tree);
            }
        };
        this.setSubContainer = (element) => {
            this.setState({
                subContainer: element,
            });
        };
        this.state = {
            subContainer: null,
            tree: props.defaultTree || [],
        };
    }
    get tree() {
        return this.props.onTreeChange && typeof this.props.tree !== 'undefined' ? this.props.tree : this.state.tree;
    }
    BEM() {
        const classArray = ['sidemenu'];
        if (this.props.style) {
            classArray.push('sidemenu--' + this.props.style);
        }
        if (this.props.color) {
            classArray.push('sidemenu--' + this.props.color);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        return (React.createElement("nav", { className: this.BEM() },
            React.createElement("div", { className: "sidemenu__main" },
                React.createElement("div", { className: "sidemenu__view" },
                    React.createElement(SidemenuNav, { tree: this.tree, level: 0, onTreeChange: this.handleTreeChange, subContainer: this.state.subContainer || undefined, elementRef: this.props.elementRef, "aria-labelledby": this.props['aria-labelledby'] }))),
            React.createElement("div", { className: "sidemenu__sub", ref: this.setSubContainer })));
    }
}
